import { version } from '../../../../package.json';

export default class AxiosVersionStrategy {
  constructor(next) {
    this.next = next;
  }

  success(cfg) {
    const newCfg = {
      ...cfg,
      params: {
        ...cfg.params,
        websiteVersion: version,
      },
    };

    return this.next.success(newCfg);
  }

  fail(error) {
    return this.next.fail(error);
  }
}
